export default "__VITE_ASSET__BaXB$cQp__"